import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";
import { IGetReportAcoesPreventivasUseCase } from "../../../presentation/useCases/read/get_report_acoes_preventivas_use_case";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";

//GetReportAcoesPreventivasUseCase
export class GetReportAcoesPreventivasUseCase implements IGetReportAcoesPreventivasUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportAcoesPreventivas(IdAcaoQualidade: number, requiredMimeType: ReportMimeType | null,): Promise<ReportData> {
    const response = await this.repository.getReportAcoesPreventivas(IdAcaoQualidade, requiredMimeType);

    if (requiredMimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `Acoes_preventivas${IdAcaoQualidade}_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
